import api from '@/shared/api/base-api';
import {
  IAutoAddProductsParams,
  IComboProductsParams,
  IMenuProductsParams,
  IModifierProductsParams,
  IProductParams,
  ISingleProductParams,
} from '../model/product.dto';
import {
  IAutoAddProductsResponse,
  IComboProductsResponse,
  IMenuProductsResponse,
  IModifierProductsResponse,
  IProductsResponse,
} from '../model/product.rdo';
import { IProduct } from '../model/types';

const productApi = {
  getAll: async (params: IProductParams) => {
    const res = await api.get<IProductsResponse>(
      '/v2/aggregator-shipper/products',
      { params }
    );
    return res.data;
  },

  getSingle: async (id: string, params: ISingleProductParams) => {
    const res = await api.get<IProduct>(`/v2/product/${id}`, { params });
    return res.data;
  },

  getComboById: async (id: string, params: IComboProductsParams) => {
    const res = await api.get<IComboProductsResponse>(`/v2/combo/${id}`, {
      params,
    });
    return res.data;
  },

  getMenuProducts: async (params: IMenuProductsParams) => {
    const res = await api.get<IMenuProductsResponse>('/v3/menu-products', {
      params,
    });
    return res.data;
  },

  getAutoAddProducts: async (params: IAutoAddProductsParams) => {
    const res = await api.get<IAutoAddProductsResponse>(
      `/v3/aggregator/auto-add-product`,
      { params }
    );
    return res.data;
  },

  getProductModifier: async (params: IModifierProductsParams) => {
    const res = await api.get<IModifierProductsResponse>(
      '/v2/aggregator/modifier',
      {
        params,
      }
    );
    return res.data;
  },
};

export default productApi;

// export const getTags = cache(
//   async (params: Record<string, string | number>) => {
//     try {
//       const response = await api.get<{ tags: ITag[]; count: string }>(
//         `/v1/tags`,
//         { params }
//       );
//       return response;
//     } catch (error) {
//       console.error('Error:', error);
//       return null;
//     }
//   }
// );
